<section class="catalog">
  <!-- Collection Header -->
  <ng-container *ngIf="selectedCollection$ | async as selectedCollection; else productsHeader">
    <div class="mb-6 d-none d-md-block" *ngIf="getCollectionImage(selectedCollection)">
      <app-collection-header
        [imageWide]="(selectedCollection.metafields | metafieldsValue: 'main_category') === 'true'"
        [image]="getCollectionImage(selectedCollection)"
        [title]="selectedCollection.title"
        [text]="selectedCollection.description"
      >
        <span #bottomRight class="d-inline-block mb-1 text-lowercase text-light" *ngIf="products$ | async as products">
          <ng-container *ngIf="products.length > 0">
            {{ products.length }}{{ (page$ | async)?.hasNextPage ? '+' : '' }}
            {{ (products.length === 1 ? 'productresultaat-label' : 'productresultaten-label') | fromDictionary }}
          </ng-container>
        </span>
      </app-collection-header>
    </div>
    <header class="topbar-padding-top section-inset-t container d-block" [class.d-md-none]="getCollectionImage(selectedCollection)">
      <div class="d-flex justify-content-between align-items-center mt-4">
        <h1 class="h2">{{ selectedCollection.title }}</h1>
        <span #bottomRight class="" *ngIf="products$ | async as products">
          <ng-container *ngIf="products.length > 0">
            {{ products.length }}{{ (page$ | async)?.hasNextPage ? '+' : '' }}
            {{ (products.length === 1 ? 'productresultaat-label' : 'productresultaten-label') | fromDictionary }}
          </ng-container>
        </span>
      </div>
    </header>
  </ng-container>

  <!-- Default Header -->
  <ng-template #productsHeader>
    <header class="catalog__header mb-4 pt-4">
      <div class="container topbar-padding-top">
        <h1 class="fw-bold mb-0">
          {{ searchQuery ? searchQuery : ('producten-overzicht-titel' | fromDictionary) }}
        </h1>
        <ng-container *ngIf="searchQuery">
          <span class="d-inline-block mb-1 text-lowercase" *ngIf="products$ | async as products">
            {{ products.length }}{{ (page$ | async)?.hasNextPage ? '+' : '' }}
            {{ (products.length === 1 ? 'zoekresultaat-label' : 'zoekresultaten-label') | fromDictionary }}
          </span>
        </ng-container>
      </div>
    </header>
  </ng-template>

  <div class="container">
    <main class="row">
      <div class="quick-filters mb-4" *ngIf="activeFilters2.length">
        <ul class="quick-filters__group button-group">
          <!-- <li class="button-group__item">
          <button class="button button-outline button--secondary" (click)="resetFilters()">Alle producten</button>
        </li> -->
          <li class="button-group__item" [class.is-last-quick-action]="activeFilters2.length">
            <button class="button button-outline button--secondary" (click)="resetFilters()">
              {{ 'product-overzicht-snelle-filters-reset' | fromDictionary }}
            </button>
          </li>

          <!-- <ng-container *ngIf="(selectedCollection$ | async)?.filters as filters"></ng-container> -->

          <li class="button-group__item" *ngFor="let filter of activeFilters2">
            <button class="button button-outline button--secondary" (click)="removeFilter(filter)">
              <span>{{ filter.label }}</span>
              <span class="button__floating-chip chip chip--xxs">
                <app-icon class="icon-xxxs" anchor="icon-close-xxs"></app-icon>
              </span>
            </button>
          </li>
        </ul>
      </div>

      <div class="d-md-none mb-2" *ngIf="(filters$ | async)?.length">
        <button class="button button-link button--secondary" (click)="setFilterPanelState(true)">
          <app-icon anchor="icon-settings"></app-icon>
          <span>{{ 'product-overzicht-mobiel-open-filters-knoptekst' | fromDictionary }}</span>
          <span class="chip chip--xs ms-2" *ngIf="activeFilters2.length > 0">{{ activeFilters2.length }}</span>
        </button>
      </div>
      <ng-container *ngIf="filters$ | async as filters">
        <section class="col-md-3 col-lg-2 filter-bar" [class.is--open]="filtersPanelOpen" *ngIf="filters.length">
          <header class="filter-bar__header d-md-none">
            <h2 class="h4 mb-0 fw-normal">{{ 'product-overzicht-mobiel-filters-titel' | fromDictionary }}</h2>
            <button (click)="setFilterPanelState(false)">
              <app-icon anchor="icon-close-xs"></app-icon>
            </button>
          </header>
          <app-product-filters
            *ngIf="(collectionLoading$ | async) !== true"
            #filterComponent
            class="filter-bar__filters"
            [filters]="filters"
            [initWithValue]="route.snapshot.queryParams"
            (filtered)="handleFilterForm($event)"
          ></app-product-filters>

          <footer class="filter-bar__footer d-md-none">
            <button class="button button-link button--secondary me-3 filter-bar__header__reset" (click)="resetFilters()">
              {{ 'product-overzicht-mobiel-filters-resetten-knoptekst' | fromDictionary }}
            </button>
            <button class="button button--secondary" (click)="applyFilters()">
              <span>{{ 'product-overzicht-mobiel-filters-toepassen-knoptekst' | fromDictionary }}</span>

              <span class="chip chip--xs ms-2 chip--light" *ngIf="activeFiltersLength">{{ activeFiltersLength }}</span>
            </button>
          </footer>
        </section>
      </ng-container>
      <div [ngClass]="(filters$ | async)?.length ? 'col-md-9 col-lg-10 ps-md-2' : 'col-12'">
        <ul class="row" *ngIf="products$ | async as products">
          <li class="mb-5 col-6 col-md-4" *ngFor="let product of products; trackBy: trackByFn">
            <app-product-card
              (addToCart)="handleAddToCart($event)"
              [collectionHandle]="(selectedCollection$ | async)?.handle"
              [product]="product"
              [sizes]="{ xs: 6, md: 2, lg: 1 }"
            ></app-product-card>
          </li>

          <li class="mb-5 col-12 my-2 text-center" *ngIf="!products.length && (loading$ | async) === false">
            <p>{{ 'product-overzicht-geen-resultaten' | fromDictionary }}</p>
            <button class="ms-2 button button--secondary" (click)="resetFilters()">
              {{ 'product-overzicht-filters-resetten-knoptekst' | fromDictionary }}
            </button>
          </li>

          <li class="mb-5 col-12 my-2 text-center" *ngIf="!products.length && (loading$ | async)">
            <p>{{ 'product-overzicht-loading' | fromDictionary }}</p>
          </li>
        </ul>
      </div>
      <div class="text-center my-5" *ngIf="!activeFiltersLength && (page$ | async)?.hasNextPage">
        <button class="button button-outline button--secondary" (click)="loadMore(page$)" [disabled]="(loading$ | async) === true">
          <span *ngIf="(loading$ | async) === true" class="icon-loader css-icon" title="loading..."></span>
          <span>{{ 'product-overzicht-meer-laden-fallback-knoptekst' | fromDictionary }}</span>
        </button>
      </div>

      <div class="text-center my-5" *ngIf="activeFiltersLength && (filteredPage$ | async)?.hasNextPage">
        <button class="button button-outline button--secondary" (click)="loadMore(filteredPage$)" [disabled]="(loading$ | async) === true">
          <span *ngIf="(loading$ | async) === true" class="icon-loader css-icon" title="loading..."></span>
          <span>{{ 'product-overzicht-meer-laden-fallback-knoptekst' | fromDictionary }}</span>
        </button>
      </div>

      <ng-container *ngIf="selectedCollection$ | async as selectedCollection">
        <ng-container
          *ngIf="getHtmlFromRichText(selectedCollection.metafields | metafieldsValue: 'collection_description_rich') as htmlText"
        >
          <article
            class="catalog__text"
            *ngIf="(htmlText | stripHtml).length > 0"
            [ngClass]="{ expanded: collectionTextExpanded || (htmlText | stripHtml).length < 600 }"
          >
            <div class="markdown-content" [innerHTML]="htmlText"></div>

            <div *ngIf="htmlText && (htmlText | stripHtml).length > 600">
              <button class="button button-link button--md button--secondary" (click)="collectionTextExpanded = !collectionTextExpanded">
                <span *ngIf="!collectionTextExpanded">{{ 'product-overzicht-collectie-toon-meer-knoptekst' | fromDictionary }}</span>
                <span *ngIf="collectionTextExpanded">{{ 'product-overzicht-collectie-toon-minder-knoptekst' | fromDictionary }}</span>
              </button>
            </div>
          </article>
        </ng-container>
      </ng-container>
    </main>
  </div>
</section>

<app-json-ld [json]="scheme"></app-json-ld>
<app-json-ld [json]="breadcrumbScheme"></app-json-ld>
